// extracted by mini-css-extract-plugin
module.exports = {"login":"LogoutButton_login__TYI8g","logout":"LogoutButton_logout__G88Y3"};